<template>
  <div class="app-container comment-list">
    <div class="comment-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="comment-list-filter-value" v-model.trim="search.content" @keyup.enter.native="searchChange" placeholder="评论内容" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="comment-list-filter-value" v-model.trim="search.commentByName" @keyup.enter.native="searchChange" placeholder="评论人Birth Name或Full Name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="comment-list-filter-value" v-model.trim="search.commentToName" @keyup.enter.native="searchChange" placeholder="回复对象Birth Name或Full Name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="comment-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="comment-list-filter-value" placeholder="是否已下架" v-model="search.isBanned" clearable size="small">
              <el-option
                v-for="item in bannedCommentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="comment-list-filter-value" v-model.trim="search.banComment" @keyup.enter.native="searchChange" placeholder="下架原因" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-button class="comment-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="comment-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "comment-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="content"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toPostCommentDetail(scope.row.contentId)"
              class="comment-list-container-button">
            {{scope.row.content}}</a>
        </template>

        <template slot="commentByName"
                  slot-scope="scope">
          <a v-if="scope.row.commentByMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentById);"
              class="comment-list-container-button">
            {{scope.row.commentByName}}</a>
          <a v-if="scope.row.commentByMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.commentById);"
              class="comment-list-container-button">
            {{scope.row.commentByName}}</a>
          
        </template>

        <template slot="commentByRealname"
                  slot-scope="scope">
          <a v-if="scope.row.commentByMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentById);"
              class="comment-list-container-button">
            {{scope.row.commentByRealname}}</a>
          <a v-if="scope.row.commentByMemberType === 1" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentByRelatedPersonalMemberId);"
              class="comment-list-container-button">
            {{scope.row.commentByRealname}}</a>
        </template>

        <template slot="commentToContent"
                  slot-scope="scope">
          <a v-if="scope.row.commentToContentId" href="javascript:void(0);" @click="toPostCommentDetail(scope.row.commentToContentId)"
              class="comment-list-container-button">
            {{scope.row.commentToContent}}</a>
          <span v-else>{{scope.row.commentToContent}}</span>
        </template>

        <template slot="commentToName"
                  slot-scope="scope">
          <a v-if="scope.row.commentToId && scope.row.commentToMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentToId);"
              class="comment-list-container-button">
            {{scope.row.commentToName}}</a>
          <a v-if="scope.row.commentToId && scope.row.commentToMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.commentToId);"
              class="comment-list-container-button">
            {{scope.row.commentToName}}</a>
        </template>
        <template slot="commentToRealname"
                  slot-scope="scope">
          <a v-if="scope.row.commentToId && scope.row.commentToMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentToId);"
              class="comment-list-container-button">
            {{scope.row.commentToRealname}}</a>
          <a v-if="scope.row.commentToId && scope.row.commentToMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.commentToId);"
              class="comment-list-container-button">
            {{scope.row.commentToRealname}}</a>
        </template>

        <template slot="postTitle"
                  slot-scope="scope">
          <div class="title">
            <div class="post-cover-image" v-if="scope.row.postCoverImg">
              <img :src="scope.row.postCoverImg" v-viewer>
            </div>
            <a href="javascript:void(0);" @click="handleView(scope.row,scope.index);"
                class="comment-list-container-button">
              {{scope.row.postTitle}}
            </a>
          </div>
        </template>
        <template slot="menu"
                  slot-scope="scope" width=100>
          <el-button size="mini"
                type="text"
                icon="el-icon-upload2"
                title="上架"
                v-if="permissions.comment_up && scope.row.isBanned"
                @click="handleUp(scope.row,scope.index)">上架
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-download"
                title="下架"
                v-if="permissions.comment_down && !scope.row.isBanned"
                @click="handleDown(scope.row,scope.index)">下架
          </el-button>
        </template>

      </avue-crud>
    </basic-container>
    <el-dialog
      title="下架"
      :visible.sync="banDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="down-dialog-item-label">下架原因</el-label>
          <el-input v-model="banDialogComment"></el-input>
        </div>
        <div>
          <!-- <el-checkbox class="down-dialog-item-label" v-model="banDialogIsSendWx">是否发送消息通知</el-checkbox> -->
          <el-input type="textarea" :rows="3" v-if="banDialogIsSendWx" v-model="banDialogSendWxMessage" placeholder="消息"></el-input>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="banDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDownSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {fetchCommentList, putComment} from '@/api/post/comment'
  import {listTableOption} from '@/const/crud/comment/list'
  import {mapGetters} from "vuex";

  export default {
    name: "table_post",
    data() {
      return {
        bannedCommentOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        search: {
          current: 1,
          size: 10,
          sortField: "",
          sortPolicy: "",
          isBanned: "",
          content: "",
          commentByName: "",
          commentToName: "",
          commentNameList: "",
          banComment: "",
          searchTime: [],
        },
        tableData:[],
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        tableLoading: false,
        tableOption: listTableOption,
        banDialogComment: "",
        banDialogVisible: false,
        banDialogIsSendWx: false,
        banDialogSendWxMessage: "",
        banDialogRow: undefined,
      };
    },
    async created() {
      this.getList();
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      formatData(records) {
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if(!record.postTitle) {
              record.postTitle = "--"
            }
            if (record.commentBy) {
              record.commentByName = record.commentBy.name
              record.commentByRealname = record.commentBy.memberType === 1 
                ? ( record.commentBy.relatedPersonalRealname ? record.commentBy.relatedPersonalRealname : record.commentBy.realname)
                : record.commentBy.realname;
            } else {
              record.commentByName = "--"
              record.commentByRealname = "--"
            }
            if (record.commentTo) {
              record.commentToName = record.commentTo.name
              record.commentToRealname = record.commentTo.realname
            } else {
              record.commentToName = "--"
              record.commentToRealname = "--"
              record.commentToContent = "--"
              record.commentToTime = "--"
            }
            if (record.postIsDeleted) {
              record.postStatus = "删除"
            } else if (record.postIsBanned === 1) {
              record.postStatus = "下架"
            } else {
              record.postStatus = "正常"
            }
            record.isNotBanned = record.isBanned ? '是' : '否';
            if (!record.banComment) {
              record.banComment = "--"
            }

            record.contentId = record.id;
            record.commentById = record.commentBy.id;
            record.commentByMemberType = record.commentBy.memberType;
            record.commentByRelatedPersonalMemberId = record.commentBy.relatedPersonalMemberId;
            if (record.commentTo) {
              record.commentToId = record.commentTo.id;
              record.commentToMemberType = record.commentTo.memberType;
              record.commentToRelatedPersonalMemberId = record.commentTo.relatedPersonalMemberId;
            }
            record.commentToContentId = record.commentToContentId;
          })
        }
        return records
      },
      getList() {
        const params = {
          current: this.search.current,
          size: this.search.size
        }
        // 增加搜索功能
        if (this.search.content != "" && this.search.content.trim() != "")
          params.content = this.search.content
        if (this.search.commentByName != "" && this.search.commentByName.trim() != "")
          params.commentByName = this.search.commentByName
        if (this.search.commentToName != "" && this.search.commentToName.trim() != "")
          params.commentToName = this.search.commentToName
        if (this.search.commentNameList != "" && this.search.commentNameList.trim() != "") {
          const list = this.search.commentNameList.split(",").filter(name => name && name.trim() != "")
          if (list.length <= 1) {
            return this.$message({
              message: "互动查询时请输入至少两位员工的名称!",
              type: "warning",
            });
          }
          params.commentNameList = list.join(",")
        }
          
        if (this.search.isBanned !== null && this.search.isBanned !== "")
          params.isBanned = this.search.isBanned;

        if (this.search.banComment != "" && this.search.banComment.trim() != "")
          params.banComment = this.search.banComment

        if (this.startTime && this.endTime) {
          params.commentStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.commentEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.commentStartTime = null
          params.commentEndTime = null
        }

        // 增加排序功能
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        else
          params.sortField = "comment_time"
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy
        else
          params.sortPolicy = "desc"

        this.tableLoading = true
        fetchCommentList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
        this.search.sortField = ""
        this.search.sortPolicy = ""
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.content = ""
        this.search.commentByName = ""
        this.search.commentToName = ""
        this.search.searchTime = []
        this.search.commentNameList = ""
        this.search.isBanned = ""
        this.search.banComment = ""
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getList()
      },
      handleSortChange(val) {
        // 检查排序对象
        if (val.prop == "commentCount") {
          this.search.sortField = "comment_count"
        }  else if (val.prop == "likeCount") {
          this.search.sortField = "like_count"
        } else {
          this.search.sortField = ""
        }
        // 检查排序方式
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortPolicy = ""
        }
        this.getList()
      },
      toMemberDetail(id) {
        this.$router.push({
          path: `/upms/member/detail/${id}`,
        })
      },
      toOfficialMemberDetail(id) {
        this.$router.push({
          path: `/upms/member/official/detail/${id}`,
        })
      },
      toPostCommentDetail(id) {
        this.$router.push({
          path: `/post/comment/${id}`,
        });
      },
      handleView(row, index) {
        if (row.postId){
          this.$router.push({
            path: `/content/list/detail/${row.postId}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该内容不存在',
            type: 'warning'
          })
        }
      },
      getPostCommentDTO(row, inputIsBanned){
        let postCommentDTO= {
          id: row.id,
          isBanned: inputIsBanned,
        }
        return postCommentDTO
      },
      handleUp(row, index) {
        // 上架功能
        let postCommentDTO = this.getPostCommentDTO(row, 0)
        let _this = this
        this.$confirm('是否确认上架内容为"' + row.content + '"'+ '的评论?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return putComment(postCommentDTO);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDown(row, index) {
        this.banDialogRow = row;
        this.banDialogComment = "";
        this.banDialogIsSendWx = false;
        this.banDialogSendWxMessage = "你发布的评论未能通过审核，请重新发布内容";
        this.banDialogVisible = true;
      },
      handleDownSubmit() {
        if (!this.banDialogComment) {
          this.$message({
            showClose: true,
            message: '下架原因不能为空',
            type: 'error'
          });
          return;
        }

        if (this.banDialogIsSendWx && !this.banDialogSendWxMessage) {
          this.$message({
            showClose: true,
            message: '发送消息不能为空',
            type: 'error'
          });
          return;
        }

        let postCommentDTO = this.getPostCommentDTO(this.banDialogRow, 1);
        postCommentDTO.banComment = this.banDialogComment;
        postCommentDTO.isSendWxMessage = this.banDialogIsSendWx;
        postCommentDTO.wxMessage = this.banDialogSendWxMessage;
        putComment(postCommentDTO)
        .then(response => {
          this.getList();
          this.$message({
            showClose: true,
            type: 'success',
            message: '下架成功'
          });
        })
        .finally(() => {
          this.banDialogVisible = false;
        });
      },
    }
  };

</script>


<style lang="scss" scoped>

.comment-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-date {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 40px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}

.title {
  display: flex;
  align-items: center;
  .post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
</style>
